import moment from 'moment-timezone';
import { DEFAULT_DATE_FORMAT } from './Application_Constants';
import { isValidDate } from './helpers';

function formatDate(date, { format = DEFAULT_DATE_FORMAT, tz = null } = {}) {
    if (!isValidDate(date) && !moment.isMoment(date)) return '';

    let momentDate = moment.utc(date);
    if (tz) {
        momentDate = momentDate.tz(tz);
    } else {
        momentDate = momentDate.local();
    }

    if (!momentDate || !momentDate.isValid()) return '';

    return momentDate.format(format);
}

function formatUtcDate(date, format = DEFAULT_DATE_FORMAT) {
    if (!date) return '';
    return formatDate(date, { format, tz: 'UTC' });
}

function isMidnightUtc(date) {
    if (!date) return false;
    const m = moment.utc(date);
    return m.isValid() && m.hours() === 0 && m.minutes() === 0 && m.seconds() === 0;
}

export { formatUtcDate, isMidnightUtc };
export default formatDate;
